export const theme = {
  colors: {
    primary: '#6D3',
    paragraph: '#346',
    mainBackground: '#ffffff',
  },
};

export const inverted = {
  colors: {
    primary: '#eeeeee',
  },
};
